import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Button } from "rhombus-react";

import { hasPermission } from "utils/common";
import {
	buildDropdownList,
	BULK_SOCIAL_IMPORT_EXPORT_ACTIONS_LISTS,
	IMPORT_SOCIAL_CREATIVES,
	SOCIAL_CREATIVE_IMPORT_TEMPLATE
} from "widgets/actions/bulk/Social";
import { CREATIVES_IMPORT_EXPORT_ACTIONS_LIST } from "widgets/grid/cells/CreativeActionLists/VersionActions";
import { hasSocialConnections } from "selectors/Social";

import { TAXONOMY_IMPORT_EXPORT_ACTIONS_LIST } from "widgets/actions/bulk/Taxonomy";
import { getManualClassificationEnabled } from "selectors/Intelligence";

import "./ImportExportButton.css";

export default function ImportExportDropdown(props) {
	const { icon, theme } = props;
	const { user, hasSocial, isEmpty, libraryId } = useSelector(state => ({
		user:state.you,
		isEmpty: !Boolean(state.creatives?.items?.length),
		hasSocial:hasSocialConnections(state),
		libraryId: state.libraryProperties?.id,
	}));
	const canClassify = useSelector((state) => {
		return getManualClassificationEnabled(state) && hasPermission(state.you, "Creative Library", "Edit");
	});

	//empty library should only have import social creative and social creative import template and no icon
	let $btnText;
	let lists = [];

	if(isEmpty) {
		if (hasSocial) {
			lists.push([IMPORT_SOCIAL_CREATIVES, SOCIAL_CREATIVE_IMPORT_TEMPLATE]);
		}
		$btnText = "Import Social Creatives";
	} else {
		lists.push(CREATIVES_IMPORT_EXPORT_ACTIONS_LIST);
		if (hasSocial) {
			lists = [...lists, ...BULK_SOCIAL_IMPORT_EXPORT_ACTIONS_LISTS];
		}
		if (canClassify) { // Taxonomy
			lists.push(TAXONOMY_IMPORT_EXPORT_ACTIONS_LIST);
		}
		$btnText = "Import/Export";
	}

	if (!lists.length) { return null; }

	const dropdownMenu = buildDropdownList(lists, { user, libraryId });

	return (
		<Button
			icon={icon}
			theme={theme}
			className="import-export-button"
			style="block"
			isDropDown
			isSplit
			addClass="true"
			splitActions={dropdownMenu}
			splitValue="import-export-button"
		>
			{$btnText}
		</Button>
	);
}

ImportExportDropdown.displayName = "ImportExportDropdown";

ImportExportDropdown.propTypes = {
	icon: PropTypes.string,
	theme: PropTypes.string,
};

ImportExportDropdown.defaultProps = {
	icon: "download",
	theme: "default",
};
